import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardTitle,
  DropdownItem,
  DropdownMenu,
  Table,
  Row,
  Input,
  Col,
  Form,
  FormGroup,
  Label
} from "reactstrap";
import Select from "react-select";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button } from "components";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import moment from "moment";
import "moment/locale/es";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const ESTADO_FACTURA = "estado-factura";
const ENVIO = "envio";
const NOTA = "nota";
const INTERNET = "internet";
const AGREGAR_MOVIL = "agregar-movil";
const GASTO_EXTRA = "gasto-extra";

const PILL_ALL = "todas";
const PILL_UNREAD = "devueltas";
const PERMISSIONS = [
  118946,
  118060,
  469,
  1
];

class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de notificaciones",
      toDashboard: false,
      searchQuery: "",
      showPopUp: false,
      popUpConfirmation: null,
      popUpToShow: null,
      currentBillStatus: null,
      currentBillID: "",
      currentBillNumber: "",
      currentPill: PILL_ALL,
      notifications_viewing: 400,
      filters: {}
    };
    ////console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.getViewArticlesButton = this.getViewArticlesButton.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.searchBills = this.searchBills.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.createBillStatusPopUp = this.createBillStatusPopUp.bind(this);
    this.editBillStatusConfirmation = this.editBillStatusConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.paymentStatus = this.paymentStatus.bind(this);
    this.openBillStatusPopUpFromBill = this.openBillStatusPopUpFromBill.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.createNavigationPills = this.createNavigationPills.bind(this);
    this.createSelectedPillContent = this.createSelectedPillContent.bind(this);

    
    this.buildNotifications = this.buildNotifications.bind(this);
    this.readNotification = this.readNotification.bind(this);
    this.unreadNotification = this.unreadNotification.bind(this);
    this.passFilter = this.passFilter.bind(this);
    this.getCategories = this.getCategories.bind(this);
    this.getTypes = this.getTypes.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }
  createNotificationRedirect(redirect) {
    switch (redirect.type) {
      case "customer":
        return "/clientes/fichas/" + redirect.id;
      case "home_visit":
        return "/citas/" + redirect.id;
      case "register_box":
        return "/cajas/" + redirect.id;
      case "ticket":
        return "/tickets/" + redirect.id;
      case "contract":
        return "/contratos/" + redirect.id;
      case "task":
        return redirect.id;
      default:
        return "#";
    }
  }
  readNotification(notification) {
    // console.log("Read notification", notification);
    // console.log("this.props", this.props);
    this.props.read_notification(notification);
  }
  unreadNotification(notification) {
    console.log("Unread notification", notification);
    // console.log("this.props", this.props);
    this.props.unread_notification(notification);
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case ESTADO_FACTURA:
        return this.createBillStatusPopUp();
      case ENVIO:
        return this.createDeliveryPopUp();
      case NOTA:
        return this.createNotePopUp();
      case INTERNET:
        return this.configureInternetPopUp();
      case AGREGAR_MOVIL:
        return this.addMobilePopUp();
      case GASTO_EXTRA:
        return this.createExtraExpensePopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  passFilter(notification) {
    let result = true;
    let partial_results = [true];
    let local_result = true;
    let local_var = null;

    let filters = this.state.filters;
    // console.log("filters", filters);
    Object.keys(filters).map(filter => {
      switch (filter) {
        case "reference":
          if (
            !notification[filter]
              .toLowerCase()
              .includes(filters[filter].toLowerCase())
          )
            partial_results.push(false);
          break;
        case "title":
          if (
            !notification[filter]
              .toLowerCase()
              .includes(filters[filter].toLowerCase())
          )
            partial_results.push(false);
          break;
        case "text":
          if (
            !notification[filter]
              .toLowerCase()
              .includes(filters[filter].toLowerCase())
          )
            partial_results.push(false);
          break;
        case "departments":
          local_result = false;
          local_var = filters[filter];
          local_var.map(department => {
            if (parseInt(notification.department.id) === parseInt(department.value))
              local_result = true;
          });
          if (!local_var || local_var.length === 0) {
            partial_results.push(true);
          } else {
            partial_results.push(local_result);
          }
          break;
        case "type":
          local_result = false;
          local_var = filters[filter];
          local_var.map(type => {
            if (parseInt(notification.type.id) === parseInt(type.value))
              local_result = true;
          });
          if (!local_var || local_var.length === 0) {
            partial_results.push(true);
          } else {
            partial_results.push(local_result);
          }
          break;
        case "categories":
          local_result = false;
          local_var = filters[filter];
          local_var.map(category => {
            notification.category.map(notification_category => {
              if (parseInt(notification_category.id) === parseInt(category.value))
                local_result = true;
            });
          });
          if (!local_var || local_var.length === 0) {
            partial_results.push(true);
          } else {
            partial_results.push(local_result);
          }
          break;
        case "hide_closed":
          local_result = false;
          local_var = filters[filter];
          // Si el estado ID diferente de 118 (cerrado) pasa el filtro
          if (!local_var || (local_var && parseInt(notification.state.id) !== 118)) local_result = true;
          partial_results.push(local_result);
          break;
        default:
          break;
      }
    });

    partial_results.map(current_result => (result = result && current_result));

    return result;
  }
  createBillStatusPopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Editar estado"
        onConfirm={() => this.showPopUpConfirmation(ESTADO_FACTURA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Estado</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Estado"
                  name="estado"
                  value={this.state.currentBillStatus}
                  options={this.props.mainState.billStatuses.forOptions}
                  onChange={value =>
                    this.setState({ currentBillStatus: value })
                  }
                />
                <br></br>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case NOTA:
        this.newNoteConfirmation();
        break;
      case ESTADO_FACTURA:
        this.editBillStatusConfirmation();
        break;
      case ENVIO:
        this.newDeliverySIMConfirmation();
        break;
      case INTERNET:
        this.configureInternetConfirmation();
        break;
      case AGREGAR_MOVIL:
        this.addMobile();
        break;
      case GASTO_EXTRA:
        this.newExtraExpenseConfirmation();
        break;
      default:;
    }
  }
  editBillStatusConfirmation() {
    this.props.editBill(
      this.state.currentBillID,
      this.state.currentBillStatus.value,
      this.state.currentBillNumber
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Estado editado!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El estado ha sido editado.
        </SweetAlert>
      )
    });
  }
  openBillStatusPopUpFromBill(order) {
    console.log("################## OPEN BILL STATUS ################");
    console.log(order);
    let billID = order.order_id;
    let billStatus = order.estado_pedido;
    let billNumber = order.numero_pedido;
    let _currentBillStatus = null;
    this.props.mainState.billStatuses.forOptions.map(currentStatus => {
      if (currentStatus.label === billStatus)
        _currentBillStatus = currentStatus;
    });
    this.setState({
      currentBillID: billID,
      currentBillStatus: _currentBillStatus,
      currentBillNumber: billNumber
    });
    this.showPopUp(ESTADO_FACTURA);
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      popUpConfirmation: null
    });
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    /* if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{ */
      partialOrders = this.props.mainState.orders.slice(0).reverse();
    /* } */
    partialOrders.map((currentOrder, key) =>{
      ordersChartDates.push(
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        })
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    let firstOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[0].fecha))
        .replace(".", "");
    let lastOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[partialOrders.length-1].fecha))
        .replace(".", "");

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart,
      ordersHistoryTitle: "Histórico de notificaciones (" + firstOrderDate + " - " + lastOrderDate + ")"
    });
  }
  downloadBill(url, orderNumber, event){
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(order){
    let statusReady = null;
    let payment = order.estado_pedido;
    let statusButtonColor = "default";
    let statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    if (payment.includes("Pendiente")) {
      statusButtonColor = "warning";
      statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    } else if(payment.includes("Pagada")){
      statusButtonColor = "primary";
      statusButtonIcon = "now-ui-icons ui-1_check";
    } else if(payment.includes("Procesando")){
      statusButtonColor = "info";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
    } else /*if(payment.includes("Recibo"))*/{
      statusButtonColor = "danger";
      statusButtonIcon = "now-ui-icons ui-1_simple-remove";
    }

    statusReady =                   
    <Button
      color={statusButtonColor}
      size="sm"
      onClick={() => {this.openBillStatusPopUpFromBill(order)}}
    >
      <i className={statusButtonIcon} /> {payment}
    </Button>;

    return statusReady;
  }
  downloadButton(order){
    let button = 
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if(this.state[order]){
      button = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  viewOrderArticles(order){
    let orderDetailContent =
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">
                Concepto
              </th>
              <th className="text-center">
                Precio
              </th>     
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>;
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    })
  }  
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  getViewArticlesButton(order) {
    let button = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" /> Ver
        </div>
      </Button>;

    if(true /*order in this.props.mainState.ordersArticles*/){
      button = 
      <Link to={"/facturas/".concat(order)}>
        <Button
          color="info"
          size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons education_glasses" /> Ver
          </div>
        </Button>
      </Link>;
    }

    return button;
  }
  searchBills() {
    if (!this.props.mainState.isSearchingBills)
      this.props.searchBills(this.state.searchQuery, this.state.currentPill === PILL_UNREAD);
  }
  createNavigationPills() {
    // console.log("CHECK PERMISSION");
    // console.log(this.props.mainState);
    // if (!PERMISSIONS.includes(parseInt(this.props.mainState.user.uid))) return null;
    return (
      <div>
        <Button
          round
          key={"pill1"}
          color={this.state.currentPill === PILL_ALL ? "primary" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_ALL});
          }}
          leftLabel={"now-ui-icons design_bullet-list-67"}
        >
          Todas
        </Button>
        {" "}
        <Button
          round
          key={"pill2"}
          color={this.state.currentPill === PILL_UNREAD ? "danger" : "default"}
          onClick={() => {
            this.setState({currentPill: PILL_UNREAD});
          }}
          leftLabel={"now-ui-icons ui-1_email-85"}
        >
          Sin leer {this.props.state.notifications && Object.keys(this.props.state.notifications).length > 0 ? "(" + Object.keys(this.getUnreadNotifications(this.props.state.notifications)).length + ")" : ""}
        </Button>
        {" "}
        <Button
          round
          key={"pill-borrar-notificaciones"}
          color={"info"}
          disabled={this.props.mainState.markingAllNotificationsAsRead}
          onClick={() => {
            // console.log("props", this.props);
            this.props.readAllNotifications();
          }}
          leftLabel={this.props.mainState.markingAllNotificationsAsRead ? "now-ui-icons arrows-1_refresh-69 spin" : "now-ui-icons ui-1_simple-remove"}
        >
          {this.props.mainState.markingAllNotificationsAsRead ? "Marcando todas como leídas..." : "Marcar todas como leídas"}
        </Button>
        {" "}
      </div>
    );
  }
  createSelectedPillContent() {
    let result = null;
    let notificationsToDisplay = null;
    switch (this.state.currentPill) {
      case PILL_ALL:
        notificationsToDisplay = this.props.mainState.notifications;
        // console.log("notificationsToDisplay", notificationsToDisplay);
        result = this.createNotificationsList(notificationsToDisplay);
        break;
      case PILL_UNREAD:
        notificationsToDisplay = this.props.mainState.notifications;
        notificationsToDisplay = this.getUnreadNotifications(notificationsToDisplay);
        result = this.createNotificationsList(notificationsToDisplay);
        break;
    }
    return result;
  }
  getUnreadNotifications(notifications) {
    let unread = [];

    if (notifications && Object.keys(notifications).length > 0) {
      Object.keys(notifications).map(current_id => {
        let current = notifications[current_id];
        if (!current.isRead) unread[current_id] = current;
      });
    }

    return unread;
  }
  createNotificationsList(notificationsToDisplay) {
    let contentToDisplay = 
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Últimas notificaciones</CardTitle>
          </CardHeader>
          <CardBody>
            <div id="notifications-list">
              {this.buildNotifications(notificationsToDisplay).notifications}
            </div>
          </CardBody>
        </Card>
      </Col>;
    return contentToDisplay;
  }
  getTypes() {
    if(this.props.mainState.notifications && Object.keys(this.props.mainState.notifications).length > 0) {
      let notifications = this.props.state.notifications;
      let types = [];
      let types_options = [];
      if (notifications) {
        types = [];
        Object.keys(notifications).map(notification => {
          notification = notifications[notification];
          types[notification.type.id] = notification.type;
          // types.push(notification.type);
        });
        Object.keys(types).map(type => {
          type = types[type];
          types_options.push({
            label: type.name, //this.buildTicketCategory(category),
            value: parseInt(type.id)
          });
        });
      }
      return types_options;
    } else {
      return [];
    }

    // console.log("departments options", departments_options);

  }
  getCategories() {
    if(this.props.mainState.notifications && Object.keys(this.props.mainState.notifications).length > 0) {
      let notifications = this.props.state.notifications;
      let categories = [];
      let categories_options = [];
      if (notifications) {
        categories = [];
        Object.keys(notifications).map(notification => {
          notification = notifications[notification];
          if (notification.category) {
            notification.category.map(category => {
              categories[category.id] = category;
            });
          }
        });
        Object.keys(categories).map(category => {
          category = categories[category];
          categories_options.push({
            label: category.name, //this.buildTicketCategory(category),
            value: parseInt(category.id)
          });
        });
      }
      return categories_options;
    } else {
      return [];
    }

    // console.log("departments options", departments_options);

  }
  buildNotifications(raw_notifications) {
    let count = 0;
    let notifications = null;
    let number_showing = 0;
    let notifications_ids = [];

    if (raw_notifications && Object.keys(raw_notifications).length > 0)
      notifications_ids = Object.keys(raw_notifications).reverse();
    // console.log("notifications_ids", notifications_ids);

    if (notifications_ids.length > 0) {
      notifications = [];
      // console.log("Ya tenemos notifications en getNotifications", raw_notifications);
      notifications_ids.map(current_id => {
        if (number_showing >= this.state.notifications_viewing) return;
        let current = raw_notifications[current_id];
        if (this.passFilter(current)) {
          if (!current.isRead) count++;
          let notification_type = <span className={"type " + current.type.name.toLowerCase()}></span>;
          let notification_category = current.category.map(category => {
            return <span key={category.id} className={"category " + category.id}>{category.name}</span>;
          });
          let notification_text = <div style={{display: "contents"}} dangerouslySetInnerHTML={{ __html: current.text }} />;
          let notification_state = current.isRead ? "read" : "unread";
          let date_class = "notification-date " + notification_state;
          let notification_date = <span className={date_class}>{moment(current.date).fromNow()}</span>;
          let notification = (
            <div
              className={"notification " + notification_state}
              onClick={() => {
                this.readNotification(current.id);
                if (current.hasRedirect) this.redirectTo(this.createNotificationRedirect(current.redirect));
              }}
              onContextMenu={e => {
                e.preventDefault();
                this.unreadNotification(current.id);
              }}
              key={current_id}
            >
              {notification_type}{notification_category}{notification_text}
              <br />
              {notification_date}
            </div>
          );
          notifications.push(notification);
          number_showing++;
        }
      });
    }

    return {
      count: count,
      notifications: notifications
    };
  }
  render() {
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    //console.log()
    let contentToDisplay = null;
    let notificationsToDisplay = null;
    let filters = (
      <Row key="ticket-list-header" xs={12}>
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <FormGroup>
                    <Input
                      type="text"
                      placeholder="Texto"
                      value={this.state.filters.text || ""}
                      onChange={e => {
                        let filters = this.state.filters;
                        filters.text = e.target.value;
                        this.setState({ filters: filters });
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      isMulti
                      closeMenuOnSelect={false}
                      placeholder="Seleccionar categoría"
                      name="categories"
                      value={this.state.filters.categories}
                      options={this.getCategories()}
                      noOptionsMessage={() => "Cargando categorías"}
                      onChange={value => {
                        let filters = this.state.filters;
                        filters.categories = value;
                        this.setState({ filters: filters });
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      isMulti
                      closeMenuOnSelect={false}
                      placeholder="Seleccionar tipo"
                      name="type"
                      value={this.state.filters.type}
                      options={this.getTypes()}
                      noOptionsMessage={() => "Cargando tipos"}
                      onChange={value => {
                        let filters = this.state.filters;
                        filters.type = value;
                        this.setState({ filters: filters });
                      }}
                    />
                  </FormGroup>
                </Col>
                {/* <Col>
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" onChange={e => { 
                        // console.log("ocultar cerrados", e.target.checked);
                        let filters = this.state.filters;
                        filters.hide_closed = e.target.checked;
                        this.setState({ filters: filters });
                      }} />
                      <span className="form-check-sign" />
                      Ocultar cerrados
                    </Label>
                  </FormGroup>
                </Col> */}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
    // console.log("#################### BILLS LIST #####################");
    // console.log(this.props.mainState);
    if(this.props.mainState.notifications && Object.keys(this.props.mainState.notifications).length > 0){
      // ordersToDisplay = this.props.mainState.orders.slice(0);
      contentToDisplay = this.createSelectedPillContent();
    } else if(this.props.mainState.notifications && this.props.mainState.notifications.length == 0 /*&& this.props.mainState.isSearchBillResult*/) {
    } else {
      contentToDisplay = 
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">¡Un momentito!</CardTitle>
          </CardHeader>
          <CardBody className="text-center">
            <div id="notifications-list">
              <span>
                <i className="now-ui-icons arrows-1_refresh-69 spin" />
                  {"  Cargando notificaciones..."}
              </span>
            </div>
          </CardBody>
          <CardFooter></CardFooter>
        </Card>
      </Col>;
    }
    let navigationPills = this.createNavigationPills();
    // let navigationPillContent = this.createSelectedPillContent();

    let orderArticles = 
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Detalles de la notificación"
        onConfirm={() => this.hideDetail()}
        showConfirm={true}
      >
        {this.state.orderDetail}
      </SweetAlert>;
    return (
      <div id="notifications-page">
        <PanelHeader
          content={
            <div className="header text-center">
              <h2 className="title">Notificaciones</h2>
              {/* <p className="category">
                El ojo que todo lo ve
              </p> */}
            </div>
          }
        />
        <div className="content">
          {filters}
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
           {/*<Row>
            <Col lg={3} md={6} xs={12}>
              <Card>
                <CardBody className="form-inline">
                  <Input type="text" 
                    placeholder="Buscar notificaciones..."
                    value={this.state.searchQuery}
                    onChange={(e) => this.handleChange("searchQuery", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if(e.keyCode == 13){
                        //Enter is key code 13
                        this.searchBills();
                        // put the login here
                      }
                    }}
                    style={{marginRight:"10px"}}
                  />
                  <Button
                    color={
                      this.props.mainState.isSearchingBills
                        ? "default"
                        : "primary"
                    }
                    round 
                    icon 
                    onClick={this.searchBills}>
                <i className={this.props.mainState.isSearchingBills?
                                      "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_zoom-bold"} />
              </Button>
                </CardBody>
              </Card> 
            </Col>
          </Row>*/}
          <Row>
            {this.state.showDetail && orderArticles}
            {navigationPills}
            {contentToDisplay}
          </Row>
        </div>
      </div>
    );
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/views/Notifications/Notifications.jsx